const UsuariosHome = () => import(/* webpackChunkName: "group-users" */ '../_views/UsuariosHome')
const CadastroUsuario = () => import(/* webpackChunkName: "group-users" */ '../_views/CadastroUsuario')
const AtualizarUsuario = () => import(/* webpackChunkName: "group-users" */ '../_views/AtualizarUsuario')

import { permissoesUsuarios } from '../../../utils/permissoesUsuarios'

export default [
  {
    path: 'home',
    component: UsuariosHome,
    meta: { requiresAuth: true, permissions: [...permissoesUsuarios] },
    name: 'UserHome',
  },
  {
    path: 'criar',
    component: CadastroUsuario,
    meta: {
      requiresAuth: true,
      permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_TOTAL],
    },
    name: 'UserHome/criar',
  },
  {
    path: 'atualizar/:id',
    component: AtualizarUsuario,
    meta: { requiresAuth: true, permissions: [...permissoesUsuarios] },
    name: 'UserHome/atualizar',
    props: true,
  },
]
